module.exports = __webpack_public_path__ + "static/media/02.c3273a15.jpg";